import config from 'config/environment';
import { TwilioError } from './types';

const twilioErrorHelpTexts = new Map<number, string>([
  [
    21610,
    `<span key='1'>Ask the applicant to text <b key='2'>"START"</b> to ${config.HAULSAFE_PHONE_NUMBER} to resume receiving messages.</span>`,
  ],
]);

const defaultErrorHelpText =
  'Update the driver’s phone number or send their upload link by email.';

export const twilioErrorHelpTextMapper = (error?: TwilioError): string => {
  // If you're going to use something from sources you don't trust, use something like this: https://www.npmjs.com/package/sanitize-html
  if (!error || !error.code) {
    return defaultErrorHelpText;
  }

  return twilioErrorHelpTexts.get(error.code) || defaultErrorHelpText;
};
